var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import Box from '../../../Box';
var Header = styled(Box).attrs({
  as: 'header'
})(_templateObject || (_templateObject = _taggedTemplateLiteralLoose([""])));
Header.displayName = 'Card.Header';
export default Header;